import React from 'react';
import { ConfiguratorUIElementStates } from '@/elements/base/ElementState';
import { Button } from '@canvas-logic/clp-shared-ui';
import classNames from 'classnames';
import { IUiCfgContainer, IUiCfgContainerExpandable } from '@canvas-logic/clp-api-types';
import { ElementRenderer } from '@/elements/ElementRenderer';

export const ContainerCfgUIElement = ({
  viewElement,
  childrenItems,
}: {
  childrenItems: ConfiguratorUIElementStates[];
  viewElement: IUiCfgContainer;
}) => {
  // `expandable`, `defaultExpanded` and `title` come from `IUiCfgContainerExpandable`,
  // which only the Mixed and Product Merge members mix in. On the Root and Component
  // Items members they read back as `undefined` — the fallback this renderer relies on.
  const { expandable, defaultExpanded, title } = viewElement as IUiCfgContainerExpandable;

  const [expanded, setExpanded] = React.useState(!expandable || !!defaultExpanded);

  return (
    <div
      className={classNames('cp-container', expanded && 'cp-container--expanded')}
      data-element-id={viewElement.id}
      key={viewElement.id}
    >
      {!!title && (
        <div className={'cp-container__title'}>
          <div className={'cp-container__title__text'}>{title}</div>
          {expandable && (
            <div className={'cp-container__title__collapsible'}>
              <Button
                variant="ghost"
                iconStart={expanded ? 'chevronUp' : 'chevronDown'}
                onClick={() => setExpanded(!expanded)}
              />
            </div>
          )}
        </div>
      )}

      <div className={classNames('cp-expandable-wrapper', !expanded && 'cp-expandable-wrapper--collapsed')}>
        <div className="cp-expandable-wrapper__inner">
          <div className={'cp_container__content'}>
            {childrenItems.map((child) => (
              <ElementRenderer key={child.id} state={child} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
